// extracted by mini-css-extract-plugin
export var audioPlayer = "_mn-0";